import { render, staticRenderFns } from "./pickupList.vue?vue&type=template&id=64e4946b&scoped=true&"
import script from "./pickupList.vue?vue&type=script&lang=js&"
export * from "./pickupList.vue?vue&type=script&lang=js&"
import style0 from "./pickupList.vue?vue&type=style&index=0&id=64e4946b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e4946b",
  null
  
)

export default component.exports